// i18n.js

import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);



import enMessages from './lang/en';
import frMessages from './lang/fr';
import ptMessages from './lang/pt';
import arMessages from './lang/ar';

const messages = {
  en: enMessages,
  fr: frMessages,
  pt: ptMessages,
  ar: arMessages,
};

export default messages;

const ayoba = window.getAyoba();

let defaultLocale = null;


if (ayoba != null) {

  const countryCode = ayoba.getCountry().toUpperCase()
  let locale = ayoba.getLanguage();


    // console.log('Country code:', countryCode, 'Locale:', locale);

    if (locale != null && ['en', 'fr', 'pt', 'ar'].includes(locale.substring(0, 2))) {
        locale = locale.substring(0, 2);
    } else if (countryCode != null) {
        const frCountries = ['CI', 'BF', 'CG', 'CD', 'NE', 'BJ', 'CG', 'CM', 'FR', 'ML', 'SN', 'TG'];
        const ptCountries = ['GW', 'AO'];
        const arCountries = ['EG', 'MR'];

        if (frCountries.includes(countryCode)) {
            locale = 'fr';
        } else if (ptCountries.includes(countryCode)) {
            locale = 'pt';
        } else if (arCountries.includes(countryCode)) {
            locale = 'ar';
        } else {
            locale = 'en'; // Default to English for unsupported countries
        }
    } else {
        locale = 'en'; // Default to English if both country code and locale are null
    }


    defaultLocale = locale;
  
}else {

  // Detect browser's locale
const browserLocale = navigator.language || navigator.userLanguage;

 defaultLocale = browserLocale.split('-')[0]; // Extracts the generic locale



if (!Object.keys(messages).includes(defaultLocale)) {
  // If the generic locale is not supported, fallback to English
  defaultLocale = 'en';
}
}



// console.log(defaultLocale);

export const i18n = new VueI18n({
  locale: defaultLocale, // default locale
  messages,
});
